import { Location } from "../models/Location";
import { host, getRequest, patchRequest, postRequest, deleteRequest } from "./apiService";

export async function getLocations() {
  return getRequest<Location[]>(`${host}/api/location`);
}

export async function updateLocation(location: Location) {
  return patchRequest<void>(
    `${host}/api/location/${location.id}`, location
  );
}

export async function addLocation(location: Location) {
  const { id, ...objectWithoutId } = location;
  return postRequest<Location | undefined>(
    `${host}/api/location`, objectWithoutId
  );
}

export async function deleteLocation(id: string) {
  return deleteRequest(`${host}/api/location/${id}`)
}